
import { BuildUrlParams, DataMasterPathsEnum, DataMasterPathBuilder, SecurityPathBuilder, SecurityPathsEnum } from 'services/Paths';
import api from 'services/Interceptor';
import { GetCompaniesParams, CompanyListResponse, CompanyResponse, PostCompanyBody, UpdateCompanyBody, GetCompaniesAuditParams, CompanyAuditListResponse } from '../interface/CompanyInterface';
import { GetUserCompanyParams, UserCompanyListResponse } from '../interface/UserCompanyInterface';

export const GetUserCompany = async (params: GetUserCompanyParams = {}): Promise<UserCompanyListResponse> => {
    let url = `${SecurityPathBuilder(SecurityPathsEnum.UserCompany)}`;

    const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
    if (urlParams) {
        url += `?${urlParams}`;
    }

    const { data } = await api.get(url);
    return data;
};

// export const GetCompanies = async (params: GetCompaniesParams = {}): Promise<CompanyListResponse> => {
//     let url = `${DataMasterPathBuilder(DataMasterPathsEnum.Companies)}`;

//     const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
//     if (urlParams) {
//         url += `?${urlParams}`;
//     }

//     const { data } = await api.get(url);
//     return data;
// };

// export const GetCompanyById = async (id: number, params: GetCompaniesParams): Promise<CompanyResponse> => {
//     let url = `${DataMasterPathBuilder(DataMasterPathsEnum.Companies)}/${id}`;

//     const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
//     if (urlParams) {
//         url += `?${urlParams}`;
//     }

//     const { data } = await api.get(url);
//     return data;
// };

// export const PostCompany = async (body: PostCompanyBody): Promise<CompanyResponse> => {
//     const url = DataMasterPathBuilder(DataMasterPathsEnum.Companies);
//     const { data } = await api.post(`${url}`, body);
//     return data;
// };

// export const UpdateCompany = async (id: number, body: UpdateCompanyBody): Promise<CompanyResponse> => {
//     const url = `${DataMasterPathBuilder(DataMasterPathsEnum.Companies)}/${id}`;
//     const { data } = await api.put(url, body);
//     return data;
// };

// export const DeleteCompany = async (companyId: number): Promise<CompanyResponse> => {
//     const url = `${DataMasterPathBuilder(DataMasterPathsEnum.Companies)}/${companyId}`;
//     const response = await api.delete(url);
//     return response.data;
// };

// export const ActivateCompany = async (id: number): Promise<CompanyResponse> => {
//     const url = `${DataMasterPathBuilder(DataMasterPathsEnum.Companies)}/${id}/activate`;
//     const { data } = await api.patch(url);
//     return data;
// };

// export const GetCompaniesAudit = async (params: GetCompaniesAuditParams = {}): Promise<CompanyAuditListResponse> => {
//     let url = `${DataMasterPathBuilder(DataMasterPathsEnum.Companies)}/audit`;

//     const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
//     if (urlParams) {
//         url += `?${urlParams}`;
//     }

//     const { data } = await api.get(url);
//     return data;
// };